export default __webpack_public_path__ + "static/media/iic 14.046f9f7b.jpg";